export default __webpack_public_path__ + "contentweb/app/pages/MRX/MRXSolutions/audience-image.8941c5ad.png";